import { makeStyles } from "@material-ui/core/styles";

export const useImageViewerStyles = makeStyles(() => ({
    root: {
      margin: 0,
      padding: "16px 24px"
    },
    closeButton: {
      position: 'absolute',
      right: "8px",
      top: "8px",
      color: "#9e9e9e",
    },
    imageContainer: {
        display: "flex",
        flex: 1,
        width: "100%",
        overflow: "auto",
        padding: 0,
    },
    imageBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
}));